
import React, {FC} from 'react';
import classNames from 'classnames';
import {NavProps} from 'components/Header';
import MenuNav, {Groups, Logout, Welcome} from 'components/Header/MenuNav';

import * as styles from './styles.module.scss';
import * as linkStyles from 'components/Header/MenuNav/Group/Link/styles.module.scss';

type DesktopNavProps = NavProps & {
	className: string
	name: string
}

const DesktopNav: FC<DesktopNavProps> = ({nav, className, name}) => {
	return (
		<MenuNav className={classNames(styles.nav, className, linkStyles.hoverEnable)}>
			<Welcome>{name}</Welcome>
			<Groups nav={nav}>
				{(groups, className) => (
					<>
						<div className={className}>
							{groups.slice(0, 3)}
						</div>
						<div className={styles.divider} />
						<div className={className}>
							{groups.slice(3)}
							<Logout />
						</div>
					</>
				)}
			</Groups>
		</MenuNav>
	);
};

export default DesktopNav;
